import React, { useEffect, useState } from "react";
import Select from "react-select";
import API from "../../utils/API";

const LenderSelectSingle = ({
        name,
        value,
        onChange,
        lenders: providedLenders,
    }) => {
    const [allLenders, setAllLenders] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [isLoading, setIsLoading] = useState(!providedLenders);
    const [error, setError] = useState(null);

    const mapIdToLender = (id, lendersList) => {
        if (!id || !lendersList) {
            return null;
        }
        return lendersList.find((lender) => lender.value === id);
    };

    useEffect(() => {
        if (!providedLenders) {
            setIsLoading(true);
            setError(null);

            API.get("/system/lenders")
                .then((response) => {
                    const options = response.data.data;
                    const formattedLenders = options
                        ? options.map((option) => ({
                            value: option.id,
                            label: `#${option.id}, ${option.title}`,
                        }))
                        : [];

                    const initialSelection = mapIdToLender(value, formattedLenders);
                    setSelectedValue(initialSelection);
                    setAllLenders(formattedLenders);
                })
                .catch((err) => {
                    console.error("Failed to fetch lenders:", err);
                    setError("Error loading lenders");
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [providedLenders, value]);

    const lendersToUse = providedLenders
        ? providedLenders.map((lender) => ({
            value: lender.id,
            label: `#${lender.id}, ${lender.title}`,
        }))
        : allLenders;

    const handleSelectChange = (selectedOption) => {
        setSelectedValue(selectedOption);
        onChange(name, selectedOption ? selectedOption.value : null);
    };

    return (
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={lendersToUse}
            value={selectedValue}
            onChange={handleSelectChange}
            isMulti={false}
            isClearable={true}
            isDisabled={isLoading || !!error}
            isLoading={isLoading}
            placeholder={error || (isLoading ? "Loading Lenders..." : "Select a Lender...")}
        />
    );
};

export default LenderSelectSingle;